import React from 'react';

const SocialIcon = ({ type }) => {
  const renderIcon = () => {
    switch (type) {
      case 'facebook':
        return (
          <svg
            width="36"
            height="36"
            viewBox="0 0 36 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="social-icon"
            style={{ width: '36px', height: '36px', position: 'relative' }}
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M18.0162 36C27.9007 36 36 27.9007 36 18.0162C36 8.09888 27.9007 0 18.0162 0C8.09888 0 0 8.09888 0 18.0162C0 27.9007 8.09888 36 18.0162 36Z"
              fill="#009CDA"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M14.9035 10.1929C14.9035 7.32041 17.2241 5 20.096 5H24V10.1929H21.3851C20.686 10.1929 20.096 10.7822 20.096 11.4819V14.0961H24V19.2883H20.096V31H14.9035V19.2883H11V14.0961H14.9035V10.1929Z"
              fill="white"
            />
          </svg>
        );
      case 'twitter':
        return (
          <svg
            width="36"
            height="36"
            viewBox="0 0 36 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="social-icon"
            style={{ width: '36px', height: '36px', position: 'relative' }}
          >
            <path
              d="M18 36C27.9411 36 36 27.9411 36 18C36 8.05887 27.9411 0 18 0C8.05887 0 0 8.05887 0 18C0 27.9411 8.05887 36 18 36Z"
              fill="#404040"
            />
            <path
              d="M19.905 16.4695L27.3512 8H25.5869L19.1184 15.3524L13.9558 8H8L15.8086 19.1192L8 28H9.76429L16.591 20.2338L22.0442 28H28L19.905 16.4695ZM17.4877 19.2168L16.6954 18.1089L10.4005 9.30146H13.1108L18.1925 16.412L18.9815 17.5199L25.5861 26.7619H22.8758L17.4877 19.2168Z"
              fill="white"
            />
          </svg>
        );
      case 'instagram':
        return (
          <svg
            width="36"
            height="36"
            viewBox="0 0 36 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="social-icon"
            style={{ width: '36px', height: '36px', position: 'relative' }}
          >
            <defs>
              <linearGradient id="paint0_linear_instagram" x1="7.67492" y1="32.7461" x2="28.3254" y2="3.25418" gradientUnits="userSpaceOnUse">
                <stop stopColor="#FF9900" />
                <stop offset="1" stopColor="#9100EB" />
              </linearGradient>
            </defs>
            <path
              d="M18 36C27.9411 36 36 27.9411 36 18C36 8.05887 27.9411 0 18 0C8.05887 0 0 8.05887 0 18C0 27.9411 8.05887 36 18 36Z"
              fill="url(#paint0_linear_instagram)"
            />
            <path
              d="M23.1562 29.25H12.8438C9.48375 29.25 6.75 26.5165 6.75 23.1562V12.8438C6.75 9.48347 9.48375 6.75 12.8438 6.75H23.1562C26.5165 6.75 29.25 9.48347 29.25 12.8438V23.1564C29.25 26.5165 26.5165 29.25 23.1562 29.25ZM12.8438 8.62509C10.5176 8.62509 8.62509 10.5176 8.62509 12.8438V23.1564C8.62509 25.4827 10.5176 27.3752 12.8438 27.3752H23.1562C25.4824 27.3752 27.3749 25.4827 27.3749 23.1564V12.8438C27.3749 10.5176 25.4824 8.62509 23.1562 8.62509H12.8438Z"
              fill="white"
            />
            <path
              d="M18 23.625C14.8984 23.625 12.375 21.1013 12.375 18C12.375 14.8981 14.8984 12.375 18 12.375C21.1016 12.375 23.625 14.8981 23.625 18C23.625 21.1013 21.1016 23.625 18 23.625ZM18 14.2501C15.9323 14.2501 14.2501 15.9323 14.2501 18C14.2501 20.068 15.9323 21.7499 18 21.7499C20.0677 21.7499 21.7499 20.068 21.7499 18C21.7499 15.9323 20.068 14.2501 18 14.2501Z"
              fill="white"
            />
            <path
              d="M23.9765 13.3123C24.6883 13.3123 25.2654 12.7352 25.2654 12.0233C25.2654 11.3115 24.6883 10.7344 23.9765 10.7344C23.2646 10.7344 22.6875 11.3115 22.6875 12.0233C22.6875 12.7352 23.2646 13.3123 23.9765 13.3123Z"
              fill="white"
            />
          </svg>
        );
      default:
        return null;
    }
  };

  return (
    <a href="#" className="flex relative flex-col items-start self-stretch pt-6 rounded-3xl cursor-pointer" aria-label={`Visit our ${type} page`}>
      {renderIcon()}
    </a>
  );
};

export default SocialIcon;
